import Locator from '../Locator';

export const BASE_ENDPOINT = '/api/packages';

/**
 * API Endpoints used for fetching packages.
 */
export const ENDPOINTS = {
  FETCH_PACKAGES: BASE_ENDPOINT,
  PACKAGE_INDEX_REPORT: `${BASE_ENDPOINT}/report`,
};

/**
 * Version path segment and label for a package revision that has no version, such as a Composer
 * `php` platform requirement or a Go standard library package. Analysis reports these as unresolved
 * dependencies, and the package cache stores them as the bare package locator. The space keeps it
 * from colliding with a real version string.
 */
export const UNKNOWN_VERSION = 'Unknown Version';

/**
 * Builds the package revision locator addressed by a `:packageLocator/:version` URL pair.
 */
export const toPackageRevisionLocator = (packageLocator: string, version: string): Locator =>
  new Locator(version === UNKNOWN_VERSION ? packageLocator : `${packageLocator}$${version}`);
